

// THIS MODEL IS NOT CRECT AND NEEDS UPDATING (think I updated it and works.)

// tslint:disable-next-line:quotemark
 import {Deserializable} from "./deserializable.model";

export class SystemLog {

  public log_id?: number;
  public log_content?: string;
  public created_by?: number;
  public created_date?: any;
  public subject_id?: number;
  public job_id?: number;
  public job_reference_number?: string;
  public file_number?: string;
  public reference_number?: string;
  public subject_number?: string;
  public log_type_id?: any;
  public created_level?: any;
  public brand_type_id?: any;
  public subject_com_type_id?: number;
  public subject_template_doc_id?: number;
  public log_name?: string;
  public log_action?: string;
  public file_id?: number;
  
  public work_order_id?: number;
  public agent_id?: number;
  public brand_id?: number;
  public user_id?: number;
  public brand_report_id?: number;
  public brand_invoice_id?: number;
  public subject_service_id?: number;
  public note_id?: number;

  public ip_address?: string;
  public remote_addr?: string;
  public remote_host?: string;
  public request_time?: string;
  public query_string?: string;
  public server_port?: string;
  public remote_port?: string;
  public request_method?: string;
  public request_url?: string;
  public server_signature?: string;


// search model
public when_from?: any;
public when_to?: any;
public limit?: number;

// conversions
public brand_type_name?: string;
public log_type_name?: string;
public kpi_log_type_array?: any; // a set of log types to measure and display as KPI indicators in system activity
public Duration?: any; // a set of log types to measure and display as KPI indicators in system activity
public days_duration?: any; // a set of log types to measure and display as KPI indicators in system activity
log_type_id_group?
saved_file_name?
created_by_group?

/*
  log_id
  log_content
  created_by
  created_date
  subject_id
  job_id
  job_reference_number
  file_number
  reference_number
  subject_number
  log_type_id
  created_level
  brand_type_id
  subject_com_type_id
  subject_template_doc_id
  log_name
  log_action
  file_id

    work_order_id
  agent_id
  brand_id
  user_id
  brand_report_id
  brand_invoice_id
  subject_service_id
  note_id

*/


  // ? what does this really do? (no encoding or deserialisation required...)
 /*
  deserialize(input: any): SystemLog {
    Object.assign(this, input);

    return this;
  }
*/

}

  // Set the Stats
